import { EmployeeRolesEnum, ErrorResponse, FgStatusEnum, GlobalStatus, JobCompletedEnum, OperationTypeEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { CommonResponse, ItemsDropDownDto, ItemsDropDownResponseModel, MasterInfoFromIndentResponse, PlantIdRequest, UnitTypeEnum } from "@gtpl/shared-models/masters";
import { AllProdInvResponseModel, InventoryWipResponse, LotAndOperationReq, LotCodeDropDown, LotCodeDropDownResponse, LotNoInfo, LotNumberInfoResponse, LotNumberReportResponseModel, LotSos, LotTrackingResponse, ProdInvData, ProdInvResponseModel, ProductionInventoryDetails, ProductionInventoryResponse, subPlantHistoryReport, SubPlantResponseModel, TreeStructureData,WipData, WipQuantityResponseModel } from "@gtpl/shared-models/production-management";
import { forwardRef, Inject, Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { getManager, Raw, Repository } from "typeorm";
import { LotInfoRequest } from "./dto/lot-info.request";
import { LotNumberRequest } from "./dto/lot-number.request";
import { ProdInvAdapter } from "./dto/prod-inv.adapter";
import { ProdInvDTO } from "./dto/prod-inv.dto";
import { ProductionInventory } from "./entities/production-inventory.entity";
import { ProductionInventoryRepository } from "./repositories/production-inventory.repository";
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { HLpercentagesService, SuppliersService } from '@gtpl/shared-services/masters';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { ProductionLogService } from './production-log.service';
import { OperationSequenceRequest } from "./dto/operation-sequence.request";
import { VariantOperationsService } from "../variant-operations/variant-operations.service";
import { ProductionLogRepository } from "./repositories/production-log.repository";
import { subplantReportRequest } from "./dto/subplanthistory-request";
import { GrnInformationDto } from "./dto/grn-information.dto";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { ProductionLogData } from "./dto/production-log.dto";
import { ProductionLog } from "./entities/production-log.entity";
import { LotCodeOpsEntity } from "./entities/lot-code.entity";
import appSettings from 'apps/services/config';
import { LotCodeOpsRepository } from "./repositories/lot-code.repository";
import { ItemsDetails, SaleOrderDropDownDto, SaleOrderDropDownResponseModel, SaleOrderItemsDropDownResponseModel } from "@gtpl/shared-models/sale-management";
import { UnitRequest } from "./dto/unit.id.request";
import { salordeIdandsoItemIdReq } from "./dto/so-and-soitem-request";
import { ProductionLogRequest } from "libs/shared-models/production-management/src/lib/production-inv/production-log.req";
import { unitRequiest } from "@gtpl/shared-models/warehouse-management";
import { LotCodeRequest } from "./dto/lot-code.request";
const util = require('util')
@Injectable()
export class ProductionInventoryService {
  constructor(
    @InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
    private prodInvAdapter: ProdInvAdapter,
    // private productAdapter: ProductAdapter,
    private saleOrderService: SaleOrderService,
    private variantOpService: VariantOperationsService,
    private supplierService: SuppliersService,
    private indentService: IndentService,
    private productionLogService: ProductionLogService,
    @InjectRepository(ProductionLogRepository)
    private logRepository: ProductionLogRepository,
    private saleService: SaleOrderService,

  ) { }

  async createGrnInventory(grnDto: GrnInformationDto): Promise<ProdInvResponseModel> {
    const manager = new GenericTransactionManager();
    try {
      // Create Production Inventory
      const grn = new ProductionInventory();
      grn.lotNumber = grnDto.lotNumber;
      grn.subLotNumber = grnDto.lotNumber;
      grn.saleOrderId = grnDto.saleOrderId;
      grn.saleOrderItemId = grnDto.saleOrderItemId;
      grn.operation = OperationTypeEnum.GRN;
      grn.nextOperation = OperationTypeEnum.BE_HEADING;
      grn.physicalQuantity = grnDto.quantity;
      grn.inputGrade = grnDto.count;
      grn.plantId = grnDto.plantId;
      grn.subPlantId = grnDto.subPlantId;
      grn.boxes = grnDto.boxes;
      grn.opBoxes = grnDto.boxes;
      grn.weighmentReq = GlobalStatus.NO;
      grn.status = FgStatusEnum.OPEN;
      grn.createdUser = grnDto.createdUser;
      // grn.plantLotNumber = grnDto.remarks;
      console.log(grnDto)
      await manager.startTransaction();
      const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(grn);
      // job number generation 
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0;
      let toDate = 0;
      let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.GRN } })).length;


      if (CurrentMonth < 4) {
        fromDate = (CurrentYear-1);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);
      }

      totalRecords = totalRecords + 1;

      var refNo = totalRecords + "";
      while (refNo.length < 4) refNo = "0" + refNo;

      const grnJobNo = "GRN/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

      // Create Log
      const productionLogObj = new ProductionLog();
      productionLogObj.lotNumber = grnDto.lotNumber;
      productionLogObj.subLotNumber = grnDto.lotNumber;
      productionLogObj.saleOrderId = grnDto.saleOrderId;
      productionLogObj.saleOrderItemId = grnDto.saleOrderItemId;
      productionLogObj.operationType = OperationTypeEnum.GRN;
      productionLogObj.jobNumber = grnJobNo;
      productionLogObj.plantId = grnDto.plantId;
      // productionLogObj.plantLotNumber=grnDto.remarks;
      if (grnDto.subPlantId) {
        productionLogObj.subPlantId = grnDto.subPlantId;
        productionLogObj.workStationType = WorkStationTypeEnum.EXTERNAL;
      }
      productionLogObj.jobStatus = JobCompletedEnum.NO;
      productionLogObj.inputGrade = grnDto.count;
      productionLogObj.inputQuantity = grnDto.quantity;
      productionLogObj.inputBoxes = grnDto.boxes;
      productionLogObj.assignedUser = grnDto.createdUser;
      productionLogObj.createdUser = grnDto.createdUser;
      productionLogObj.prodInvId = prodInvResponse.productionInventoryId;
      const createLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);

      const lotCodeOps = new LotCodeOpsEntity();
      lotCodeOps.grnDate = grnDto.grnDate;
      lotCodeOps.indentId = grnDto.indentId;
      lotCodeOps.grnNumber = grnDto.grnNumber;
      lotCodeOps.lotNumber = grnDto.lotNumber;
      lotCodeOps.saleOrderId = grnDto.saleOrderId;
      lotCodeOps.saleOrderItemId = grnDto.saleOrderItemId;
      lotCodeOps.supplierType = grnDto.supplierType;
      lotCodeOps.farmer = grnDto.farmer;
      lotCodeOps.farmerCode = grnDto.farmerCode;
      lotCodeOps.quantity = grnDto.quantity;
      lotCodeOps.count = grnDto.count;
      lotCodeOps.price = grnDto.price;
      lotCodeOps.boxes = grnDto.boxes;
      lotCodeOps.plantId = grnDto.plantId;
      lotCodeOps.subPlantId = grnDto.subPlantId;
      lotCodeOps.isActive = true;
      lotCodeOps.createdUser = grnDto.createdUser;
      lotCodeOps.lotNumber = grnDto.lotNumber;

      const savedLotCodeOpsEntity: LotCodeOpsEntity = await manager.getCustomRepository(LotCodeOpsRepository).save(
        lotCodeOps
      );

      if (prodInvResponse && createLog && savedLotCodeOpsEntity) {
        await manager.completeTransaction();
        return new ProdInvResponseModel(true, 1111, 'Grn Information Updated to Production Successfully');
      } else {
        await manager.releaseTransaction();
        throw new ErrorResponse(9999, 'Failed To Update Production');
      }
    } catch (error) {
      await manager.releaseTransaction();
      return error;
    }
  }

  async getProdInvDetailsWithoutRelations(lotNumber: string): Promise<ProductionInventory> {
    // tslint:disable-next-line: typedef
    const prodInvResponse = await this.inventoryRepository.findOne({
      where: { lotNumber: Raw(alias => `lot_number = '${lotNumber}'`) },
    });
    if (prodInvResponse) {
      return prodInvResponse;
    } else {
      return null;
    }
  }


  async createProdInv(prodInvDto: ProdInvDTO, isUpdate: boolean): Promise<ProdInvResponseModel> {
    // console.log(statesDto);

    try {
      // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
      if (!isUpdate) {
        const prodInvEntity = await this.getProdInvDetailsWithoutRelations(prodInvDto.lotNumber);
        if (prodInvEntity) {
          //return new InformationMessageError(11104, "State already exists");
          throw new ErrorResponse(11104, 'ProdInv already exists');
        }
      }
      else {
        const prodInvEntity = await this.getProdInvDetailsWithoutRelations(prodInvDto.lotNumber);
        if (prodInvEntity) {
          if (prodInvEntity.productionInventoryId != prodInvDto.productionInventoryId) {
            throw new ErrorResponse(11104, 'ProdInv already exists');
          }
        }
      }
      const convertedProdInvEntity: ProductionInventory = this.prodInvAdapter.convertDtoToEntity(prodInvDto, isUpdate);
      const savedProdInvEntity: ProductionInventory = await this.inventoryRepository.save(
        convertedProdInvEntity
      );
      const savedProdInvDto: ProdInvDTO = this.prodInvAdapter.convertEntityToDto(convertedProdInvEntity);
      // console.log(savedStateDto);
      if (savedProdInvDto) {
        // generating resposnse
        const response = new ProdInvResponseModel(true, 1, isUpdate ? 'ProdInv Updated Successfully' : 'ProdInv Created Successfully');
        return response
      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'ProdInv saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      return error;
    }
  }

  async getAllProdInvs(): Promise<AllProdInvResponseModel> {
    // const page: number = 1;
    try {
      const prodInvDtos: ProdInvData[] = [];

      const prodInvEntities = await this.inventoryRepository.createQueryBuilder('production_inventory')
        .where('physical_quantity+intransit_quantity-issued_quantity>0').getMany();

      console.log(prodInvEntities);
      if (prodInvEntities.length === 0) {
        throw new ErrorResponse(10000, 'No Records Found');
      }
      for (const grn of prodInvEntities) {
        const soInfo = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: grn.saleOrderId })
        console.log(soInfo);
        const soREq: saleOrder = {
          saleOrderId: grn.saleOrderId
        }
        const soItemInfo = await this.saleOrderService.getSaleOrderItemsForSo(soREq);
        prodInvDtos.push(new ProdInvData(grn.productionInventoryId, grn.lotNumber, grn.saleOrderId, grn.saleOrderItemId, grn.physicalQuantity, grn.issuedQuantity, grn.intransitQuantity, grn.wastageQuantity, grn.wipQuantity, grn.rejectedQuantity, grn.inputGrade, grn.boxes, grn.plantId, soInfo.saleOrderNumber, soItemInfo.data.itemsDetails[0].item, grn.subPlantId, grn.weighmentReq, grn.operation, grn.nextOperation, grn.status, grn.createdUser))
      }
      return new AllProdInvResponseModel(true, 1, 'Production inventories retrieved successfully', prodInvDtos);
    } catch (err) {
      return err;
    }
  }
  async getLotNumbers(req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.inventoryRepository.getLotNumbers(req);
      if (lotCodes && lotCodes.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }
  
  async getLotNumberInfo(lotNoReq: LotInfoRequest): Promise<LotNumberInfoResponse> {
    try {
      // const lotNoInformation = await this.inventoryRepository.findOne({select:['lotNumber','issuedQuantity','saleOrderId','saleOrderItemId','inputGrade','boxes', 'physicalQuantity'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId, nextOperation:lotNoReq.presentOperation}});
      const lotNoInformation = await this.inventoryRepository.getLotNumberInfo(lotNoReq);
      console.log(lotNoInformation)

      if (lotNoInformation) {
        let availBoxes = lotNoInformation[0].boxes;
        let boxWeight = lotNoInformation[0].physicalQuantity / lotNoInformation[0].boxes;
        if (lotNoReq.presentOperation == OperationTypeEnum.BE_HEADING || lotNoReq.presentOperation == OperationTypeEnum.GRADING || lotNoReq.presentOperation == OperationTypeEnum.VALUE_ADDITION) {
       
        console.log('availlll',lotNoInformation[0].availableQuantity)
        console.log('opkjuty',lotNoInformation[0].opBoxes-lotNoInformation[0].transferredBoxes)


          availBoxes = (lotNoInformation[0].opBoxes-lotNoInformation[0].transferredBoxes);

          const getReportedQty = await this.productionLogService.getOperationQuantity(lotNoReq.lotNumber, lotNoReq.plantId, lotNoReq.presentOperation);
          console.log('getReportedQty',getReportedQty)
          if (getReportedQty) {
            // availQty = Number(availQty) - Number(getReportedQty.quantity)
            availBoxes = Number(availBoxes) - Number(getReportedQty.boxes);
            console.log(availBoxes,'availBoxes');
          }
          boxWeight = (lotNoInformation[0].availableQuantity) / (availBoxes);
        }
        console.log(availBoxes,'availBoxesnewww');

        const soInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: lotNoInformation[0].saleOrderItemId })
        console.log("*********soInfo*********");
        console.log(soInfo);

        const lotInfo = new LotNoInfo(lotNoInformation[0].lotNumber, lotNoInformation[0].saleOrderId, soInfo.data.poNumber, lotNoInformation[0].saleOrderItemId, '', lotNoInformation[0].inputGrade, lotNoInformation[0].availableQuantity, availBoxes, lotNoInformation[0].prodInvId, lotNoInformation[0].inputGrade, lotNoInformation[0].outputGrade, boxWeight, soInfo.data.soakingTime, soInfo.data.soakingStyle, lotNoInformation[0].opBoxes,lotNoInformation[0].lot,lotNoInformation[0].mainPlantId,soInfo.data.poNumber);
        console.log(lotInfo,'lotInfo')
        return new LotNumberInfoResponse(true, 1111, 'Lot No Info Retrieved Successfully', lotInfo);
      } else {
        throw new ErrorResponse(9999, 'Unable to get lot info')
      }
    } catch (error) {
      return error;
    }
  }


  async getLotNumberInfoForBeheading(lotNoReq: LotInfoRequest): Promise<LotNumberInfoResponse> {
    try {
      // const lotNoInformation = await this.inventoryRepository.findOne({select:['lotNumber','issuedQuantity','saleOrderId','saleOrderItemId','inputGrade','boxes', 'physicalQuantity'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId, nextOperation:lotNoReq.presentOperation}});
      const lotNoInformation = await this.inventoryRepository.getLotNumberInfoForBeheading(lotNoReq);
      if (lotNoInformation) {
        let availBoxes = lotNoInformation.boxes;
        if (lotNoReq.presentOperation == OperationTypeEnum.BE_HEADING || lotNoReq.presentOperation == OperationTypeEnum.GRADING) {
          const getReportedQty = await this.productionLogService.getOperationQuantity(lotNoReq.lotNumber, lotNoReq.plantId, lotNoReq.presentOperation);
          if (getReportedQty) {

            // availQty = Number(availQty) - Number(getReportedQty.quantity)
            availBoxes = Number(availBoxes) - Number((getReportedQty.boxes > 0 ? Number(getReportedQty.boxes):0));
          }
        }
        
        const boxWeight = (lotNoInformation.physicalQuantity) / (lotNoInformation.boxes?lotNoInformation.boxes:1);
        console.log(boxWeight);
        const soInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: lotNoInformation.saleOrderItemId })

        const lotInfo = new LotNoInfo(lotNoInformation.lotNumber, lotNoInformation.saleOrderId, soInfo.data.saleOrderNo, lotNoInformation.saleOrderItemId, '', lotNoInformation.inputGrade, lotNoInformation.availableQuantity, availBoxes, lotNoInformation.prodInvId, lotNoInformation.inputGrade, lotNoInformation.outputGrade, boxWeight, soInfo.data.soakingTime, soInfo.data.soakingStyle, lotNoInformation.opBoxes);

        return new LotNumberInfoResponse(true, 1111, 'Lot No Info Retrieved Successfully', lotInfo);
      } else {
        throw new ErrorResponse(9999, 'Unable to get lot info')
      }
    } catch (error) {
      return error;
    }
  }


  async getSaleOrdersForLot(lotNoReq: LotInfoRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
    const soIds = await this.inventoryRepository.getSaleOrdersForLot(lotNoReq);
      if (soIds) {
        const saleOrders: SaleOrderDropDownDto[] = [];
        for (const id of soIds) {
          const soReq: saleOrder = {
            saleOrderId: id.saleOrderId
          }
          const saleOrderDetails = await this.saleService.getSaleOrderFewDetailsForSoId(soReq);
          if (!saleOrderDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Sale Order');
          }
          saleOrders.push(saleOrderDetails);
        }
        return new SaleOrderDropDownResponseModel(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
      } else {
        throw new ErrorResponse(1111, 'Failed to Get Sale Orders');
      }
    } catch (error) {
      return error
    }
  }


  async getSaleOrderItemsForLotAndSo(lotNoReq: LotInfoRequest): Promise<ItemsDropDownResponseModel> {
    try {
    const soIds = await this.inventoryRepository.getSaleOrderItemsForLotAndSo(lotNoReq);
      if (soIds) {
        const saleOrdersItems: ItemsDropDownDto[] = [];
        for (const id of soIds) {
          const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: id.saleOrderItemId })
          const item = new ItemsDropDownDto(id.saleOrderItemId, soItemInfo.data.product)
         
          saleOrdersItems.push(item);
        }
        return new ItemsDropDownResponseModel(true, 1111, 'Sale Order Items Retrieved Successfully', saleOrdersItems)
      } else {
        throw new ErrorResponse(1111, 'Failed to Get Sale Order Items');
      }
    } catch (error) {
      return error
    }
  }

  // async previousNextOpeartions(inputReq:OperationSequenceRequest){
  //   const oerationSequenceData = await this.getOperationSequence()
  // }

  //   async getLotNumberInfo(lotNoReq:LotInfoRequest):Promise<LotNumberInfoResponse>{
  //     try{

  //       let previousOperation;
  //       let nextOperation;
  //       let presentOperationReportedQty = 0;
  //       let previousOperationReportedQty = 0;
  //       let nextOperationReportedQty = 0;
  //       let soItemId = 1; //need to get from service
  //       const operationSeqData = await this.variantOpService.getOperationSequence(new OperationSequenceRequest(lotNoReq.plantId,lotNoReq.presentOperation,soItemId));
  //       if(operationSeqData.status){
  //         previousOperation = operationSeqData.data.previousOperation;
  //         nextOperation = operationSeqData.data.nextOperation;
  //         const lotNo_present_opInformation = await this.prodInvRepository.findOne({select:['lotNumber','reportedQuantity','saleOrderId','saleOrderItemId','inputGrade'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId,operation:lotNoReq.presentOperation}});
  //         const lotNo_previous_opInformation = await this.prodInvRepository.findOne({select:['lotNumber','reportedQuantity','saleOrderId','saleOrderItemId','inputGrade'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId,operation:previousOperation}});
  //         if(lotNo_present_opInformation){
  //           presentOperationReportedQty = lotNo_present_opInformation.reportedQuantity;
  //         }
  //         let availableQty = lotNo_previous_opInformation.reportedQuantity - presentOperationReportedQty;
  //           if(lotNo_previous_opInformation){
  //             const lotInfo = new LotNoInfo(lotNo_previous_opInformation.lotNumber, lotNo_previous_opInformation.saleOrderId, '', lotNo_previous_opInformation.saleOrderItemId, '', lotNo_previous_opInformation.inputGrade ,availableQty, undefined);
  //             return new LotNumberInfoResponse(true, 1111, 'Lot No Info Retrieved Successfully', lotInfo);
  //           }else{
  //             throw new ErrorResponse(9999, 'Unable to get lot info')
  //           }
  //       }else{
  //         throw new ErrorResponse(9999, 'Unable to get Operation Sequence')
  //       }
  //     }catch(error){
  //       return error;
  //     }
  // }

  async getNoOfAvailableBoxes(operation: OperationTypeEnum, plantId: number): Promise<CommonResponse> {
    try {
      const noOfBoxes = await this.inventoryRepository.getNoOfAvailableBoxes(operation, plantId);
      if (noOfBoxes) {
        return new CommonResponse(true, 1111, 'Available Boxes Found Successfully', noOfBoxes)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getQtyToBeProcessed(operation: OperationTypeEnum, plantId: number): Promise<CommonResponse> {
    try {
      const qty = await this.inventoryRepository.getQtyToBeProcessed(operation, plantId);
      if (qty) {
        return new CommonResponse(true, 1111, 'To Be Processed Quantity Found Successfully', qty)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getInventoryQty(operation: OperationTypeEnum, plantId: number): Promise<CommonResponse> {
    try {
      const qty = await this.inventoryRepository.getInventoryQty(operation, plantId);
      if (qty) {
        return new CommonResponse(true, 1111, 'Inventory Quantity Found Successfully', qty)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }
  async getSubPlantHistoryReportDetails(req?: subplantReportRequest): Promise<SubPlantResponseModel> {

    try {
      const subPlantDetails = this.logRepository.createQueryBuilder('production_log')
        .select([
          'production_log.lot_number as lotNumber,production_log.operation as operation,production_log.sale_order_id as saleOrderId,production_log.assigned_time as assignedTime,production_log.ip_boxes as ipBoxes,production_log.op_boxes as opBoxes,production_log.sub_plant_id as plantName,production_log.job_number as jobNumber,production_log.job_status as jobStatus,production_log.input_grade as inputGrade,production_log.input_quantity as inputQuantity,production_log.sub_plant_op_status as  isReceived'
        ])
      if (req) {
        if (req.fromDate && req.toDate) {
          subPlantDetails.where('Date(assigned_time) between ' + req.fromDate.toString() + ' and ' + req.toDate.toString())
        }

        if (req.soNumber) {
          subPlantDetails.andWhere('sale_order_id =' + req.soNumber)
        }

        if (req.lotNumber) {
          subPlantDetails.andWhere('lot_number ="' + req.lotNumber + '"')
        }

        if (req.operation) {
          subPlantDetails.andWhere(' operation="' + req.operation + '"')
        }

        if (req.jobNumber) {
          subPlantDetails.andWhere('job_number ="' + req.jobNumber + '"')
        }
        if (req.plantName) {
          subPlantDetails.andWhere('sub_plant_id =' + req.plantName)
        }
      }
      const plantDetails = await subPlantDetails.getRawMany();
      console.log(plantDetails);
      if (plantDetails && plantDetails.length > 0) {
        const subPlantArray: subPlantHistoryReport[] = [];

        for (const subPlantInfo of plantDetails) {
          const soInfo = await this.saleService.getSaleOrderDataForSoId({ saleOrderId: subPlantInfo.saleOrderId })
          console.log(soInfo);
          const subPlantobj = new subPlantHistoryReport(subPlantInfo.plantName, subPlantInfo.operation, soInfo.saleOrderNumber, subPlantInfo.lotNumber, subPlantInfo.jobNumber, subPlantInfo.ipBoxes, subPlantInfo.opBoxes, subPlantInfo.isReceived, subPlantInfo.inputQuantity, subPlantInfo.inputGrade, subPlantInfo.jobStatus, subPlantInfo.subPlantId)
          subPlantArray.push(subPlantobj)
        }
        const response = new SubPlantResponseModel(true, 1108, 'SubPlantHistory Report Retrieved Succesfully', subPlantArray);
        return response;
      } else {
        throw new ErrorResponse(9999, 'Failed To subPlantHistory Report')
      }
    }
    catch (error) {
      return error;
    }
  }
  async getInventoryInfo(operation: OperationTypeEnum, plantId: number): Promise<ProductionInventoryResponse> {
    try {
      // const response = await this.inventoryRepository.getInventoryInfo(operation, plantId);
      // if (response) {
      //   for (const inv of response) {
      //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: inv.saleOrderId })
      //     inv.saleOrder = soInfo.saleOrderNumber;
      //     inv.poNumber = soInfo.poNumber
      //     // inv.product = (inv.saleOrderItemId).toString();
      //     const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inv.saleOrderItemId })
      //     console.log(soItemInfo);
      //     if(soItemInfo.status){
      //       inv.product = soItemInfo.data.product;
      //     }
      //   }

        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var resQuery = `SELECT gi.remarks as plantLotNumber,CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,pi.lot_number as lotNumber, sub_lot_number as subLotNumber, pi.sale_order_id as saleOrderId, pi.sale_order_item_id as saleOrderItemId ,round(issued_quantity) as issuedQuantity, round(physical_quantity) as physicalQuantity, round(intransit_quantity) as intransitQuantity, round(wip_quantity) as wipQuantity, round(wastage_quantity) as wastageQuantity, round(rejected_quantity) as rejectedQuantity, pi.boxes as boxes, input_grade as inputGrade, output_grade as outputGrade, operation, op_boxes as opBoxes, prod_inv_id as productionInventoryId, next_operation as nextOperation, output_grade as count ,sid.po_number as poNumber, p.name as product, sc.variant_code AS productSKU,pi.plant_id AS plantId,lc.quantity as ipQty,lc.count as ipCount,round(pi.stock_transfer_qty) as transferedQuantity, round(pi.physical_quantity - pi.issued_quantity - pi.stock_transfer_qty - pi.conversion_quantity) as qty,round(pi.conversion_quantity) as conversionQty FROM `+ appSettings.production_db+`.production_inventory pi LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN `+appSettings.sales_db +`.sale_order_items soi ON soi.sale_order_item_id = pi.sale_order_item_id LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = soi.varient_id LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number= pi.lot_number LEFT JOIN `+appSettings.production_db + `.lot_code_data lc ON lc.lot_number = pi.lot_number WHERE operation="${operation}" and status!="${FgStatusEnum.CLOSE}"`
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          resQuery += "AND pi.sub_plant_id="+plantId;
        }else{
          if(plantId && plantId!=5){
              resQuery += "AND pi.plant_id="+plantId+' and pi.sub_plant_id = 0';
          }
          else{  
              resQuery += ' and pi.sub_plant_id = 0';
          }
        }
        resQuery += " Order By pi.lot_number DESC";
        const response =await manager.query(resQuery); 

      if(response.length > 0 ){

        return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
      }else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }

  async getStockInventory(operation: OperationTypeEnum, plantId: number): Promise<ProductionInventoryResponse> {
    try {
      // const response = await this.inventoryRepository.getInventoryInfo(operation, plantId);
      // if (response) {
      //   for (const inv of response) {
      //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: inv.saleOrderId })
      //     inv.saleOrder = soInfo.saleOrderNumber;
      //     inv.poNumber = soInfo.poNumber
      //     // inv.product = (inv.saleOrderItemId).toString();
      //     const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inv.saleOrderItemId })
      //     console.log(soItemInfo);
      //     if(soItemInfo.status){
      //       inv.product = soItemInfo.data.product;
      //     }
      //   }

      // LEFT JOIN `+appSettings.production_db + `.lot_code_data lc ON lc.lot_number = pi.lot_number  // removed left join getting multiple records against lot  lc.quantity as ipQty,lc.count as ipCount these info not using anywhere

        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var resQuery = `SELECT pi.input_grade AS count,pi.prod_inv_id AS prodInvId,pi.conversion_quantity AS conversionQuantity, pi.stock_transfer_qty AS transferedQty, gi.remarks as plantLotNumber,CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,pi.lot_number as lotNumber, sub_lot_number as subLotNumber, pi.sale_order_id as saleOrderId, pi.sale_order_item_id as saleOrderItemId ,round(issued_quantity) as issuedQuantity, round(physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) as physicalQuantity, round(intransit_quantity) as intransitQuantity, round(wip_quantity) as wipQuantity, round(wastage_quantity) as wastageQuantity, round(rejected_quantity) as rejectedQuantity, pi.boxes as boxes, input_grade as inputGrade, output_grade as outputGrade, operation, IF(op_boxes = 0, (pi.boxes - converted_boxes - transfered_boxes),op_boxes) as opBoxes, prod_inv_id as productionInventoryId, next_operation as nextOperation, output_grade as count ,sid.po_number as poNumber, p.name as product, sc.variant_code AS productSKU,pi.plant_id AS plantId FROM `+ appSettings.production_db+`.production_inventory pi LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN `+appSettings.sales_db +`.sale_order_items soi ON soi.sale_order_item_id = pi.sale_order_item_id LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = soi.varient_id LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number=pi.lot_number WHERE operation="${operation}" and status!="${FgStatusEnum.CLOSE}"`
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          resQuery += " AND pi.sub_plant_id="+plantId;
        }else{
          resQuery += " AND pi.plant_id="+plantId+' and pi.sub_plant_id = 0';
        }
        resQuery += " Order By (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) DESC, pi.lot_number DESC";
        const response =await manager.query(resQuery); 

      if(response.length > 0 ){

        return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
      }else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getReadyForDeheading(req:unitRequiest): Promise<ProductionInventoryResponse> {
    try {
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId;
        const result =await manager.query(query);
        var DeheadingQuery = `SELECT  p.lot_number AS lotNumber,CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,p.boxes,p.physical_quantity AS quantity,p.next_operation AS operation,sc.variant_code AS variantCode,s.varient_id AS variantId,p.prod_inv_id AS productionInventoryId,si.po_number AS poNumber ,p.sale_order_item_id AS saleOrderItemId,p.plant_id FROM `+ appSettings.production_db+`.production_inventory p 
        LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = p.sale_order_id 
        LEFT JOIN `+appSettings.sales_db +`.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id 
        LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = s.varient_id 
        LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id 
        LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number=p.lot_number 
        LEFT JOIN `+appSettings.production_db +`.lot_code_data lc ON lc.lot_number = p.lot_number WHERE p.operation="DEHEADING" AND p.physical_quantity>0 `
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          DeheadingQuery += "AND p.sub_plant_id="+req.unitId;
        }
        else{
          if(req.unitId && req.unitId!=5){
            DeheadingQuery += "AND p.plant_id="+req.unitId+' and p.sub_plant_id = 0';
          }
          else{
            DeheadingQuery += ' and p.sub_plant_id = 0';
          }
          
        }
        const response =await manager.query(DeheadingQuery); 

      if(response.length > 0 ){

        return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
      }else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getLotTrackingReportData(req: LotInfoRequest): Promise<LotNumberReportResponseModel> {
    const lotDetails = await this.inventoryRepository.getLotInformation(req);
    console.log('lotDetails'+lotDetails);
    for (const lot of lotDetails) {
      console.log(lot);
      // const data = new LotTrackingResponseDto(lot.lotNumber,lot.saleOrderId,"",lot.saleOrderItemId,"",lot.coun)
    }
    return new LotNumberReportResponseModel(false, 1001, "");
  }
  
  async getLotTrackingReportDetails(req: LotInfoRequest): Promise<LotTrackingResponse> {
    try {

      const LotDetails = await this.inventoryRepository.createQueryBuilder('production_Inventory')
        .select([
          'production_Inventory.lot_number as lotNumber,production_Inventory.operation as operation,production_Inventory.sale_order_id as saleOrderId'
        ]).orderBy('production_Inventory.lot_number').where(`lot_number='${req.lotNumber}' and plant_id='${req.plantId}'`).getRawMany();

      if (LotDetails && LotDetails.length > 0) {

        const treeData: TreeStructureData[] = [];
        const lots: string[] = [];

        const lotssos: LotSos[] = [];

        for (const lot of LotDetails) {
          if (!lots.includes(lot.lotNumber)) {
            lots.push(lot.lotNumber)
          }
        }

        for (const lot of lots) {
          const lotSo = new LotSos();
          lotSo.lotNumber = lot;
          const sos: number[] = [];
          LotDetails.filter((lotInfo) => {
            if (lotInfo.lotNumber == lot) {
              if (!sos.includes(lotInfo.saleOrderId)) {
                sos.push(lotInfo.saleOrderId)
              }
            }
          })

          lotSo.soNos = sos;
          lotssos.push(lotSo);
        }


        for (const treeInfo of lotssos) {
          const data = new TreeStructureData();
          data.title = treeInfo.lotNumber
          data.key = 'LOTNumber'
          const soArray: TreeStructureData[] = [];
          for (const so of treeInfo.soNos) {
            const soInfo = await this.saleService.getSaleOrderDataForSoId({ saleOrderId: so })

            const soData = new TreeStructureData()
            soData.title = soInfo.saleOrderNumber
            soData.key = 'saleOrderId'


            const opArray: TreeStructureData[] = [];
            LotDetails.filter((opInfo) => {

              if (opInfo.lotNumber == treeInfo.lotNumber && opInfo.saleOrderId == so) {
                const opData = new TreeStructureData();
                opData.title = opInfo.operation;
                opData.key = opInfo.operation;
                opData.physicalQuantity = opInfo.physicalQuantity;
                opData.issuedQuantity = opInfo.issuedQuantity;
                opArray.push(opData);
              }

            })
            soData.children = opArray;
            soArray.push(soData);
          }
          data.children = soArray;
          treeData.push(data);
        }

        const response = new LotTrackingResponse(true, 1108, 'LotTracking Report Retrieved Succesfully', treeData);
        return response;
      } else {
        throw new ErrorResponse(9999, 'Failed To LotTracking Report')
      }
    } catch (error) {
      return error;
    }
  }

  async assignRejectionToSo(req?: ProdInvDTO): Promise<ProductionInventoryResponse> {
    return new ProductionInventoryResponse(true, 1111, 'Rejections retrived Successfully')

  }

  async getAllRejections(req:UnitRequest): Promise<ProductionInventoryResponse> {
    try {
      // const responseData: ProductionInventoryDetails[] = [];
      // const prodInvEntities = await this.inventoryRepository.createQueryBuilder('production_inventory')
      //   .where('rejected_quantity > 0').getMany();
      //   console.log(prodInvEntities,"00000")
      // if (prodInvEntities) {
      //   for (const inv of prodInvEntities) {
      //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: inv.saleOrderId })
      //     const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inv.saleOrderItemId })
      //     const data = new ProductionInventoryDetails(inv.lotNumber, inv.subLotNumber, soInfo.saleOrderNumber, soItemInfo.data.product, inv.boxes, inv.issuedQuantity, inv.physicalQuantity, inv.intransitQuantity, inv.wipQuantity, inv.wastageQuantity, inv.rejectedQuantity, inv.inputGrade, inv.outputGrade, inv.operation, soItemInfo.data.variantCode, soItemInfo.data.variantId, inv.assignedRejection, inv.productionInventoryId,0,null,0,soInfo.poNumber);
      //     responseData.push(data);
      //   }
      //   console.log(responseData,'kkkkkk')
      //   return new ProductionInventoryResponse(true, 1111, 'Rejections retrived Successfully', responseData)
      // } else {
      //   throw new ErrorResponse(9999, 'No Data Found')
      // }
      const manager = getManager();
      const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId;
      const result = await manager.query(query);
      var responseData = `SELECT CONCAT(p.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, p.lot_number AS lotNumber,p.sub_lot_number AS subLotNumber,p.boxes,p.issued_quantity AS issuedQuantity,p.physical_quantity AS physicalQuantity,p.intransit_quantity AS intransitQuantity,p.wip_quantity AS wipQuantity,p.wastage_quantity AS wastageQuantity,p.rejected_quantity AS rejectedQuantity,p.input_grade AS inputGrade,p.output_grade AS outputGrade,p.operation,sc.variant_code AS variantCode,s.varient_id AS variantId,p.assigned_rejection AS assignedRejection,p.prod_inv_id AS productionInventoryId,so.sale_order_no AS saleOrderNumber,si.po_number AS poNumber ,p.sale_order_id AS saleOrderId,p.sale_order_item_id AS saleOrderItemId FROM `+ appSettings.production_db + `.production_inventory p 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = s.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = s.sale_order_id 
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = s.varient_id 
      LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = p.lot_number
      WHERE rejected_quantity > 0 `
      if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
        responseData += " AND p.sub_plant_id=" + req.unitId;
      } else {
        responseData += " AND p.plant_id=" + req.unitId + ' AND p.sub_plant_id = 0';
      }
      const response: ProductionInventoryDetails[] = await manager.query(responseData);
      if (response) {
        return new ProductionInventoryResponse(true, 1111, 'Rejections retrived Successfully', response)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }

  async getInventoryWipQuantity():Promise<InventoryWipResponse>{
    const invData = await this.inventoryRepository.getInventoryWipData();
    console.log(invData);
    let wipData:WipData[] = []
    if(invData){
      for(const invDataItem of invData){
        const wipDataObj = new WipData(invDataItem.wipQty,invDataItem.saleOrderId,invDataItem.saleOrderItemId);
        wipData.push(wipDataObj);
      }
      console.log(wipData);
      return new InventoryWipResponse(true,55555,'WIP quantity retreived',wipData)
    }else{
      return new InventoryWipResponse(false,99999,'No data',undefined)
    }
  }

  async getProcessedLotNumber(req: PlantIdRequest): Promise<LotCodeDropDownResponse> {
    const response:LotCodeDropDown[] = [];
    const processedLotNos = await this.inventoryRepository.getLotCodesData(req);
    for(const item of processedLotNos){
      const data = new LotCodeDropDown(item.lotNumber,item.subLotNumber);
      response.push(data);
    }
    if(response.length>0){
      return new LotCodeDropDownResponse(true,1001,"",response);
    }
    else{
      return new LotCodeDropDownResponse(false,1001,"",response);
    }
  }

  async getOperationWiseLotsInfo(req:UnitRequest):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let lotsDataQry = `SELECT GROUP_CONCAT(sub_lot_number) as lots,operation,ROUND(SUM(wip_quantity)) as wipQty,ROUND(SUM(physical_quantity)) AS inventory FROM ${appSettings.production_db}.production_inventory WHERE STATUS IN('IN_PROGRESS','OPEN') GROUP BY operation`;
      if(req.unitId && req.unitId != 5){
        lotsDataQry += ` and plant_id=` + req.unitId;
      }
      const lotsInfo = await manager.query(lotsDataQry);
      if(lotsInfo.length > 0){
        return new CommonResponse(true,5555,'data retrived',lotsInfo)
      }else{
        return new CommonResponse(false,5555,'data retrived')
      }
    }catch(Err){
      return new CommonResponse(false,4444,Err)
    }

  }

  async lotTrackingInfo():Promise<CommonResponse>{
    try{
      // const 
      return 
    }catch(err){
      return new CommonResponse(false,555,err)
    }
  }

  async getAllSoakingAssets():Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = await manager.query("Select asset_id AS assetId,asset_name AS assetName, asset_code AS assetCode, asset_type AS assetType from "+appSettings.assets_db+".asset a where a.asset_type = 'Soaking'");
      if(query.length > 0){
        return new CommonResponse(true,1001,"Assets details retrieved successfully. ",query);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }
  async getSoakingReport():Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = await manager.query("Select  asset_code AS assetCode,cron_job_time AS cronJobTime,asset_control AS assetControl,created_at AS createdAt,updated_at AS updatedAt,version_flag AS versionFlag,is_active AS isActive,asset_action_control_id AS assetActionControlId,created_user AS createdUser,updated_user AS updatedUser,tub_code AS tubCode,duration_one AS durationOne,duration_two AS durationTwo,tub_status AS tubStatus,asset_status AS assetStatus from "+appSettings.assets_db+".asset_action_control a");
      if(query.length > 0){
        return new CommonResponse(true,1001,"Assets details retrieved successfully. ",query);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }
  async getWipQuantityAgainstsoandsoitem(req:salordeIdandsoItemIdReq):Promise<WipQuantityResponseModel>{
    try{
      const manager = getManager();
      let query = await manager.query("SELECT SUM(wip_quantity) as wipQuantity FROM `erpx_dev_production`.`production_inventory` WHERE sale_order_id = "+req.saleOrderId+" AND sale_order_item_id="+req.saleOrderItemId+" and wip_quantity > 0 GROUP BY sale_order_id,sale_order_item_id");
      if(query.length > 0){
        return new WipQuantityResponseModel(true,1001,"Assets details retrieved successfully. ",query);
      }
      else{
        return new WipQuantityResponseModel(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }
  async getphysicalquantityforlotnumber(req:LotAndOperationReq):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = await manager.query("SELECT prod_inv_id,lot_number AS lotNumber,operation,ROUND(physical_quantity) AS physicalQuantity FROM production_inventory WHERE lot_number= '"+req.lotNumber+"' AND OPERATION= '"+req.operation+"'");
      if(query.length > 0){
        return new CommonResponse(true,1001,"Data Retrieved Sucessfullyy.. ",query);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }

  async getProductionLogReport(req?:ProductionLogRequest):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = "SELECT pl.lot_number AS lotNumber,si.po_number AS poNumber,DATE(pl.created_at) AS DATE,pl.sub_lot_number AS subLotNumber, pl.sale_order_id AS saleOrderId,pl. sale_order_item_id AS saleOrderItemId ,pl.input_grade AS inputGrade,ROUND(input_quantity)AS inputQuantity,ROUND(SUM(planned_output_quantity)) AS plannedOutputQuantity,ROUND(SUM(actual_output_quantity )) AS actualOutputQuantity,ROUND(SUM(p.intransit_quantity)) AS intransitQuantity,ROUND(SUM(pl.wastage_quantity)) AS wastageQuantity,ROUND(SUM(pl.rejected_quantity)) AS rejectedQuantity,ROUND(SUM(p.wip_quantity)) AS wipQuantity,ip_boxes AS ipBoxes,pl.op_boxes AS opBoxes,pl.operation, production_log_id AS productionLogId,pl.job_status AS jobStatus FROM `production_log` pl LEFT JOIN `production_inventory` p ON pl.sale_order_id = p.sale_order_id LEFT JOIN `erpx_dev_sales`.`so_invoice_details` si ON si.sale_order_id = pl.sale_order_id WHERE production_log_id >0 "

      if(req.unitId && req.unitId != 5){
        if(req.lotNumber == undefined && req.fromDate == undefined && req.toDate == undefined){
        query = query+  'and pl.plant_id = '+req.unitId;

        }
        if(req.lotNumber){
          query=query+' AND pl.lot_number = "'+req.lotNumber+'" and pl.plant_id = '+req.unitId
        }
        if(req.fromDate && req.toDate){
            query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.plant_id = '+req.unitId;
        }
        if(req.lotNumber && req.fromDate && req.toDate){
            query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber+'" and pl.plant_id = '+req.unitId ;
        }
      }
      else{
           if(req.lotNumber){
          query=query+' AND pl.lot_number= "'+req.lotNumber;
        }
        if(req.fromDate && req.toDate){
            query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate ;
        }
        if(req.lotNumber && req.fromDate && req.toDate){
          query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber ;
      }
      }
     
      const data=await manager.query(query+' GROUP BY pl.lot_number,pl.sale_order_item_id')      

      if(data){
        return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }
    catch(err){
      return err
    }
  }


  async getProductionInventoryReport(req?:ProductionLogRequest):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = "SELECT si.po_number as poNumber,lot_number AS lotNumber, sub_lot_number AS subLotNumber,DATE(p.created_at) AS DATE, p.sale_order_id AS saleOrderId, sale_order_item_id AS saleOrderItemId ,ROUND(issued_quantity) AS issuedQuantity, ROUND(physical_quantity) AS physicalQuantity, ROUND(intransit_quantity) AS intransitQuantity, ROUND(wip_quantity) AS wipQuantity, ROUND(wastage_quantity) AS wastageQuantity, ROUND(rejected_quantity) AS rejectedQuantity, boxes AS boxes, input_grade AS inputGrade, output_grade AS outputGrade, operation, op_boxes AS opBoxes, prod_inv_id AS productionInventoryId, next_operation AS nextOperation, output_grade AS COUNT FROM "+appSettings.production_db+".production_inventory p left join "+appSettings.sales_db+".so_invoice_details si on p.sale_order_id=si.sale_order_id where prod_inv_id > 0 "

      if(req.lotNumber){
        query=query+' ANd lot_number= "'+req.lotNumber+'"'
      }
      if(req.fromDate && req.toDate){
          query=query+' And DATE(p.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"';
      }
      if(req.lotNumber && req.fromDate && req.toDate){
        query=query+' And DATE(p.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and lot_number= "'+req.lotNumber+'"' ;
    }
     
      const data=await manager.query(query+' GROUP BY lot_number,sale_order_item_id')      

      if(data.length > 0){
        return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }
    catch(err){
      return err
    }
  }

  // async getLotTrackingReport(req?:ProductionLogRequest):Promise<CommonResponse>{
  //   try{
  //     const manager = getManager();
  //     let query = "SELECT p.lot_number,physical_quantity,issued_quantity,p.operation,pl.job_number,pl.workstation,pl.job_status, pl.assigned_time FROM `erpx_dev_production`.`production_inventory` p LEFT JOIN `erpx_dev_production`.`production_log` pl ON pl.sale_order_id = p.sale_order_id WHERE p.prod_inv_id > 0 "

  //     if (req.unitId && req.unitId != 5) {
  //       query = query + ' and pl.plant_id = ' + req.unitId;
  //       if(req.lotNumber){
  //         query=query+' AND p.lot_number = "'+req.lotNumber+'"'
  //       }
  //     }
  //     else{
  //         if(req.lotNumber){
  //           query=query+' AND p.lot_number = "'+req.lotNumber+'"'
  //         }
      
        
  //     }
     
  //     const data=await manager.query(query)      

  //     if(data.length > 0){
  //       return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
  //     }
  //     else{
  //       return new CommonResponse(false,1010,"No data found. ");
  //     }
  //   }
  //   catch(err){
  //     return err
  //   }
  // }

  async getLotInfo(req?: ProductionLogRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = "SELECT si.po_number as poNumber,lot_number AS lotNumber, sub_lot_number AS subLotNumber, p.sale_order_id AS saleOrderId, sale_order_item_id AS saleOrderItemId ,ROUND(issued_quantity) AS issuedQuantity, ROUND(physical_quantity) AS physicalQuantity, ROUND(intransit_quantity) AS intransitQuantity, ROUND(wip_quantity) AS wipQuantity, ROUND(wastage_quantity) AS wastageQuantity, ROUND(rejected_quantity) AS rejectedQuantity, boxes AS boxes, input_grade AS inputGrade, output_grade AS outputGrade, operation, op_boxes AS opBoxes, prod_inv_id AS productionInventoryId, next_operation AS nextOperation, output_grade AS COUNT FROM " + appSettings.production_db + ".production_inventory p left join " + appSettings.sales_db + ".so_invoice_details si on p.sale_order_id=si.sale_order_id where prod_inv_id > 0 "

      if (req.lotNumber) {
        query = query + ' ANd lot_number= "' + req.lotNumber + '"';
      }
      const data = await manager.query(query)

      if (data.length > 0) {
        return new CommonResponse(true, 1001, "Lot Info retrieved successfully. ", data);
      }
      else {
        return new CommonResponse(false, 1010, "No data found. ");
      }
    }
    catch (err) {
      return err
    }
  }

  async getInventoryLots(req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      const manager = getManager()
      const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.plant;
      const result = await manager.query(query);
      var responseData = `SELECT p.lot_number  AS lotNumber,gi.remarks AS plantLotNumber,p.sub_lot_number AS subLotNumber FROM `+ appSettings.production_db + `.production_inventory p LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number= p.lot_number WHERE p.prod_inv_id > 0  `

      if (req.operation === "REJECTION") { 
        responseData += ` and rejected_quantity > 0 `;
      }
      else{
        responseData += ` and (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) > 0 `;
      }
      if (req.operation != "GRN" && req.operation != "REJECTION") {
        responseData += ` and next_operation = '`+req.operation+`'`;
      }
      else if (req.operation === "GRN") {
        responseData += ` and operation = '`+req.operation+`'`;
      }
      if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
        responseData += " AND p.sub_plant_id=" + req.plant;
      } else {
        responseData += " AND p.plant_id=" + req.plant + ' AND p.sub_plant_id = 0';
      }
      responseData += " group by p.lot_number"
      const response = await manager.query(responseData);
      if (response && response.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', response)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }

  async getSaleOrdersByLot(req: LotCodeRequest): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.plantId;
      const result = await manager.query(query);
      var responseData = `SELECT CONCAT (p.sub_lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as sublotandplantlot,p.output_grade,p.prod_inv_id AS prodInvId,si.sale_order_id AS saleOrderId, si.sale_order_item_id AS saleOrderItemId, sid.po_number AS poNumber, sku.variant_code AS productSKU,mb.brand_name AS brand, pm.packing_method_name AS packStyleId,`
      if(req.presentOperation === "REJECTION"){
        responseData += ` rejected_quantity AS quantity, 0 AS boxes`;
      }
      else{
        responseData += ` (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) AS quantity, IF(p.operation = "GRN",(p.boxes-converted_boxes - transfered_boxes),(op_boxes-converted_boxes - transfered_boxes)) AS boxes`;
      }
      responseData += ` FROM `+ appSettings.production_db + `.production_inventory p left join `+appSettings.rm_procure_db+`.grn_items gi on p.lot_number=gi.lot_number left join `+appSettings.sales_db+`.sale_order_items si on si.sale_order_item_id = p.sale_order_item_id left join `+appSettings.masters_db+`.sku_codes sku on sku.sku_code_id = si.varient_id left join `+appSettings.sales_db+`.so_invoice_details sid on sid.sale_order_id = p.sale_order_id left join `+appSettings.masters_db+`.packing_methods pm on pm.packing_method_id = si.pack_style_id left join `+appSettings.masters_db+`.master_brands mb on mb.master_brand_id = si.master_brand_id WHERE p.lot_number = '`+req.lotNumber+`' and sku.is_active=1`;
      if(req.presentOperation === "REJECTION"){
        responseData += ` and rejected_quantity > 0`;
      }
      else{
        responseData += ` and (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) > 0`;
      }
      if (req.presentOperation != "GRN" && req.presentOperation != "REJECTION") {
        responseData += ` and p.next_operation = '`+req.presentOperation+`'`;
      }
      else if (req.presentOperation === "GRN") {
        responseData += ` and p.operation = '`+req.presentOperation+`'`;
      }
      if(result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
        responseData += " AND p.sub_plant_id=" + req.plantId;
      } else {
        responseData += " AND p.plant_id=" + req.plantId + ' AND p.sub_plant_id = 0';
      }
      const response = await manager.query(responseData);
      if (response && response.length) {
        return new CommonResponse(true, 1111, 'Lot Numbers retrieved successfully', response)
      } else {
        return new CommonResponse(false, 1110, 'Something went wrong')
      }

    } catch (error) {
      return error
    }
  }
  


}





